module.exports = __webpack_public_path__ + "static/media/moblogo.260afca0.svg";